import { __awaiter } from 'tslib';
import axios from 'axios';
import baseV3Service from './base/baseV3Service.js';
import baseInternalService from './base/internalApiBaseService.js';

const getSpaceToken = (spaceId, config) => {
    return baseV3Service.post("spaces/generate-token", { spaceId }, config);
};
const getSpaceByToken = (token, config) => {
    return baseV3Service.get(`spaces/token/${token}`, config);
};
const getSpaceById = (id, config) => {
    return baseV3Service.get(`spaces/${id}`, config);
};
const getSpaces = (config) => {
    return baseV3Service.get(`spaces`, config);
};
const getSpacesSgt = (config) => {
    return baseV3Service.get(`spaces/sgt`, config);
};
const createSpace = (payload, config) => {
    return baseV3Service.post(`spaces`, payload, config);
};
const updateSpace = (id, space, config) => {
    return baseV3Service.put(`spaces/${id}`, space, config);
};
const updateSpaceNode = (id, nodeId, node, config) => {
    return baseV3Service.put(`spaces/${id}/nodes/${nodeId}`, node, config);
};
const uploadStagedImage = (spaceId, nodeId, stagedPhoto, config) => {
    return baseV3Service.put(`spaces/${spaceId}/nodes/${nodeId}/add-staged-photo`, stagedPhoto, config);
};
const getSpaceMultiresConfig = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const multiresConfig = yield axios(url).then((response) => response.data);
    return multiresConfig.multiRes;
});
const getGMBPlaces = (config) => {
    return baseV3Service.get("spaces/gmb-places", config);
};
const uploadToGmb = (payload, config) => {
    return baseV3Service.post("spaces/gmb", payload, config);
};
const unpublishFromGmb = (payload, config) => {
    return baseV3Service.delete(`spaces/${payload}/gmb`, config);
};
const generate2dImages = (payload, config) => {
    return baseInternalService.post("/2d-image-extractor/extract", payload, config);
};
const deduplicateSpace = (payload, config) => {
    return baseV3Service.put("spaces/deduplicate", payload, config);
};
const getSimilarUnits = (spaceId, config) => {
    return baseV3Service.get(`spaces/${spaceId}/similar-units`, config);
};

export { createSpace, deduplicateSpace, generate2dImages, getGMBPlaces, getSimilarUnits, getSpaceById, getSpaceByToken, getSpaceMultiresConfig, getSpaceToken, getSpaces, getSpacesSgt, unpublishFromGmb, updateSpace, updateSpaceNode, uploadStagedImage, uploadToGmb };
